<div class="alert alert-info">
  {{ 'TICKETS.GESCHWISTER.ADD_INFO' | translate }}
</div>

<form [formGroup]="form">
  @for (nr of geschwisterSlots; track nr) {
    <div class="mb-3">
      <label class="form-label" [for]="idPrefix + nr">
        {{ 'TICKETS.GESCHWISTER.LABEL_GESCHWISTERKIND' | translate }}
      </label>
      <ng-select
        [id]="idPrefix + nr"
        [formControlName]="'geschwisterkind' + nr"
        [items]="schuelerList"
        bindValue="id"
        bindLabel="ganzerNameGeburtsdatum"
        [placeholder]="'STANDARD.NO_DATA' | translate"
        [clearable]="true"
        [searchable]="true"
        (change)="onGeschwisterkindChange(nr)"
        [attr.data-cy]="testIdPrefix + nr">
      </ng-select>
    </div>
  }
</form>
